module.exports = __webpack_public_path__ + "img/logo-b.d1c79493.svg";